// extracted by mini-css-extract-plugin
module.exports = {"postedBy":"e_Ww","postedByDate":"e_Xw","container":"e_Yw","description":"e_Zw","title":"e__w"};